<template>
  <div class="mt-5">
    <div v-if="showAlert" class="col-12">
      <mdb-alert class="d-flex justify-content-center" color="danger">
        <b>Oh no,</b>
        {{ alertText }}
      </mdb-alert>
    </div>
    <mdb-input label="Instagram username*" v-model="username" far icon="user" />
    <div class="text-center">
      <mdb-btn
        v-on:click="search"
        outline="primary"
        darkWaves
        rounded
      >Search ({{instagramAccountConnected ? '5 Tokens' : '10 Tokens*'}})</mdb-btn>
    </div>
    <br />
    <small>*Make sure the user is an business or creator account.</small>
    <p
      v-if="!instagramAccountConnected"
    >*: Save 5 tokens per search by connecting your Instagram account.</p>
  </div>
</template>

<script>
import { mdbInput, mdbBtn, mdbAlert } from "mdbvue";
export default {
  name: "ViralFinderSearchForm",
  components: {
    mdbInput,
    mdbBtn,
    mdbAlert
  },
  data: function() {
    return {
      username: ""
    };
  },
  methods: {
    search: function() {
      let username = this.username;
      const that = this;
      //const tokens = that.$store.getters["user/user"].tokens;
      that.$store.commit("ui/is_loading", true);
      this.$store
        .dispatch("igViralFinder/findViralContent", { username })
        .then(() => {
          that.$store
            .dispatch("user/updateUser")
            .then(() => {
              //const tokensNow = that.$store.getters["user/user"].tokens;
              /*if (tokensNow > tokens) {
                that.$store.commit("ui/is_loading", false);
              }*/

              that.$store.commit("ui/is_loading", false);
            })
            .catch(() => {
              that.$store.commit("ui/is_loading", false);
            });
        })
        .catch(err => {
          that.$store.commit("ui/is_loading", false);
          if (err.response.status === 402) {
            this.$router.push("/buy-tokens");
          }
          if (err.response.status === 400) {
            that.$store.commit("ui/show_alert", true);
            that.$store.commit(
              "ui/alert_text",
              "we couldn't find a (business or creator) user with this username."
            );
          }
        });
    }
  },
  computed: {
    showAlert: function() {
      return this.$store.getters["ui/showAlert"];
    },
    alertText: function() {
      return this.$store.getters["ui/alertText"];
    },
    instagramAccountConnected: function() {
      return (
        this.$store.getters["user/user"].connectedInstagramAccounts !== null &&
        this.$store.getters["user/user"].connectedInstagramAccounts.length > 0
      );
    }
  }
};
</script>
